/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetExpensePosition } from './AssetExpensePosition';
import {
    AssetExpensePositionFromJSON,
    AssetExpensePositionFromJSONTyped,
    AssetExpensePositionToJSON,
    AssetExpensePositionToJSONTyped,
} from './AssetExpensePosition';

/**
 * 
 * @export
 * @interface SrvProceedingAssetSnapshotExpenseResponse
 */
export interface SrvProceedingAssetSnapshotExpenseResponse {
    /**
     * 
     * @type {AssetExpensePosition}
     * @memberof SrvProceedingAssetSnapshotExpenseResponse
     */
    position: AssetExpensePosition;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingAssetSnapshotExpenseResponse
     */
    amount: number;
}



/**
 * Check if a given object implements the SrvProceedingAssetSnapshotExpenseResponse interface.
 */
export function instanceOfSrvProceedingAssetSnapshotExpenseResponse(value: object): value is SrvProceedingAssetSnapshotExpenseResponse {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SrvProceedingAssetSnapshotExpenseResponseFromJSON(json: any): SrvProceedingAssetSnapshotExpenseResponse {
    return SrvProceedingAssetSnapshotExpenseResponseFromJSONTyped(json, false);
}

export function SrvProceedingAssetSnapshotExpenseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingAssetSnapshotExpenseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'position': AssetExpensePositionFromJSON(json['position']),
        'amount': json['amount'],
    };
}

export function SrvProceedingAssetSnapshotExpenseResponseToJSON(json: any): SrvProceedingAssetSnapshotExpenseResponse {
    return SrvProceedingAssetSnapshotExpenseResponseToJSONTyped(json, false);
}

export function SrvProceedingAssetSnapshotExpenseResponseToJSONTyped(value?: SrvProceedingAssetSnapshotExpenseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': AssetExpensePositionToJSON(value['position']),
        'amount': value['amount'],
    };
}

